<template>
  <div class="modal">
    <div class="modal__dialog modal__dialog--centered modal__dialog--sm">
      <div class="modal__content text-center">
        <icon :icon="['fal', 'spinner-third']" class="spinner" />
        <span> {{ $t('auth.oauth.apple') }}</span>
      </div>
    </div>
    <div class="modal__backdrop"></div>
  </div>
</template>
<script>
import { captureException } from '@/utils/errors'
import { isValidState, stateToRedirectUri } from '@/utils/oauth'

export default {
  name: 'AppleLogin',
  components: {},
  created() {
    const { code, error, user, redirectUri } = this.getParams()

    const payload = { code, user, error }
    this.$store.dispatch('loginApple', payload).then((isNew) => {
      if (error) {
        this.$router.push({ name: 'Login' })
      } else if (isNew) {
        this.$router.push({ name: 'CompleteProfile' })
      } else if (redirectUri) {
        this.$router.push(redirectUri)
      }
    })
  },
  methods: {
    getParams() {
      // gather parameters from query
      // try to decode them
      // try to load it as json
      // return an object of parameters, or if anything fails an object with an error
      try {
        const { data } = this.$route.query // base64ed json
        let buff = Buffer.from(data, 'base64')
        const jsonData = buff.toString('utf-8')
        const params = JSON.parse(jsonData)
        const { state } = params

        // validate state to prevent CSRF attacks
        if (isValidState(state)) {
          params.redirectUri = stateToRedirectUri(state)
          return params
        } else {
          throw new Error('csrf verification failed')
        }
      } catch (e) {
        // capture error in Sentry
        captureException(e)
        return { error: true }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.spinner {
  font-size: 3rem;

  margin: 3rem auto;
}
</style>
